import React, { useState, useRef } from "react";
import { getDefaultAvatar } from '../utils/avatarUtils';

export function AvatarModal({
  currentAvatar,
  onClose,
  onAvatarChange,
  onConnectFacebook,   // call with (imageUrl)
  onConnectLinkedIn,   // call with (imageUrl)
}) {
  // State for UI method: "upload" | "url" | "facebook" | "linkedin" | "reset"
  const [selectedMethod, setSelectedMethod] = useState("upload");
  const [previewUrl, setPreviewUrl] = useState(currentAvatar || getDefaultAvatar());
  const [fileError, setFileError] = useState("");
  const fileInputRef = useRef();

  // --- Handle file upload ---
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      setFileError("Please select a valid image file.");
      return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
      setPreviewUrl(ev.target.result);
      setFileError("");
    };
    reader.readAsDataURL(file);
  };

  // --- Handle paste URL ---
  const [urlInput, setUrlInput] = useState("");
  const handleUrlSubmit = (e) => {
    e.preventDefault();
    if (!urlInput.match(/^https?:\/\/.+\.(jpg|jpeg|png|gif|webp)$/i)) {
      setFileError("Please enter a valid image URL.");
      return;
    }
    setPreviewUrl(urlInput);
    setFileError("");
  };

  // --- Handle OAuth Connect stubs ---
  const handleConnectFacebook = () => {
    // This will be replaced with real OAuth later!
    // Simulate: fetch FB image URL (show loading)
    setFileError("FB connect not wired up yet.");
    // onConnectFacebook && onConnectFacebook(fbImageUrl);
  };

  const handleConnectLinkedIn = () => {
    setFileError("LinkedIn connect not wired up yet.");
    // onConnectLinkedIn && onConnectLinkedIn(linkedInImageUrl);
  };

  // --- Handle reset ---
  const handleReset = () => {
    setPreviewUrl(getDefaultAvatar());
    setFileError("");
  };

  // --- Save/cancel ---
  const handleSave = () => {
    // Call parent
    if (previewUrl) {
      onAvatarChange(previewUrl);
    }
  };

  return (
    <div className="profile-avatar-modal">
      <h3>Change Your Profile Picture</h3>
      <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
        <button onClick={() => setSelectedMethod("upload")}>Upload</button>
        <button onClick={() => setSelectedMethod("url")}>Paste URL</button>
        <button onClick={() => setSelectedMethod("facebook")}>Connect Facebook</button>
        <button onClick={() => setSelectedMethod("linkedin")}>Connect LinkedIn</button>
        <button onClick={handleReset}>Reset</button>
      </div>

      {/* --- Live Preview --- */}
      <div className="cropper-preview" style={{ marginBottom: 18 }}>
        <img
          src={previewUrl}
          alt="Avatar preview"
          style={{ width: 150, height: 150, borderRadius: "50%", objectFit: "cover" }}
          onError={e => { e.target.onerror = null; e.target.src = getDefaultAvatar(); }}
        />
      </div>

      {/* --- Method controls --- */}
      {selectedMethod === "upload" && (
        <div>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>
      )}

      {selectedMethod === "url" && (
        <form onSubmit={handleUrlSubmit}>
          <input
            type="text"
            value={urlInput}
            placeholder="Paste image URL (https://...)"
            onChange={e => setUrlInput(e.target.value)}
            style={{ width: "80%" }}
          />
          <button type="submit">Preview</button>
        </form>
      )}

      {selectedMethod === "facebook" && (
        <div>
          <button onClick={handleConnectFacebook} disabled>
            Connect to Facebook (coming soon)
          </button>
        </div>
      )}

      {selectedMethod === "linkedin" && (
        <div>
          <button onClick={handleConnectLinkedIn} disabled>
            Connect to LinkedIn (coming soon)
          </button>
        </div>
      )}

      {fileError && <div style={{ color: "red", margin: "8px 0" }}>{fileError}</div>}

      <div className="avatar-modal-actions" style={{ marginTop: 20 }}>
        <button onClick={onClose} type="button">Cancel</button>
        <button onClick={handleSave} type="button">Save</button>
      </div>
    </div>
  );
}
